// extracted by mini-css-extract-plugin
module.exports = {"table":"Dillers_table__12_FO","tableItem":"Dillers_tableItem__2X42K","dillersTitle":"Dillers_dillersTitle__VoK3E","wrapper-question":"Dillers_wrapper-question__3ROO2"};